export default __webpack_public_path__ + "static/media/screen_battles.92e70c94.png";